<script>
export default {
  name: "ColorOfTasks",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    //const SlaDaysToResponse = context.props.row.SlaDaysToResponse;
    //const ExecutionDate = new Date(context.props.row.ExecutionDate);
    const ExecutionDateHasValue = context.props.row.ExecutionDate !== null;
    // const isFixed = context.props.row.IsFixed;
    const DiasRetrasados = context.props.row.DelayedDays;
    const isClosed = context.props.row.IsItClosed;
    const CloseDate = new Date(context.props.row.CloseDate);
    const DueDate = new Date(context.props.row.DueDate);

    const DaysOfWeek = new Object({
      0: "Sunday",
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday"
    });

    if (
      Number(val) > 0 ||
      col === "ID" ||
      (Number(val) === 0 &&
        DaysOfWeek[CloseDate.getDay()] === col &&
        isClosed === true) ||
      (!ExecutionDateHasValue &&
        DaysOfWeek[DueDate.getDay()] === col &&
        isClosed === false)
    ) {
      if (
        DiasRetrasados <= 0 &&
        isClosed === false
        // &&
        // (isFixed === null || isFixed === false)
      ) {
        return createElement(
          "el-tag",
          {
            attrs: {
              type: "primary"
            }
          },
          val
        );
      } else if (
        DiasRetrasados > 0 &&
        isClosed === false
        // &&
        // (isFixed === null || isFixed === false)
      ) {
        return createElement(
          "el-tag",
          {
            attrs: {
              type: "primary"
            },
            class: "Red"
          },
          val
        );
      } else if (
        DiasRetrasados <= 0 &&
        isClosed === true
        // &&
        // (isFixed === null || isFixed === false)
      ) {
        return createElement(
          "el-tag",
          {
            attrs: {
              type: "success"
            }
          },
          val
        );
      } else if (
        DiasRetrasados > 0 &&
        isClosed === true
        // &&
        // (isFixed === null || isFixed === false)
      ) {
        return createElement(
          "el-tag",
          {
            attrs: {
              type: "success"
            },
            class: "Red"
          },
          val
        );
      }

      // else if (
      //   DiasRetrasados <= 0 &&
      //   isClosed === false &&
      //   (isFixed !== null || isFixed === true)
      // ) {
      //   return createElement(
      //     "el-tag",
      //     {
      //       attrs: {
      //         type: "",
      //         effect: "dark"
      //       }
      //     },
      //     val
      //   );
      // }
      // else if (
      //   DiasRetrasados > 0 &&
      //   isClosed === false &&
      //   (isFixed !== null || isFixed === true)
      // ) {
      //   return createElement(
      //     "el-tag",
      //     {
      //       attrs: {
      //         type: "warning",
      //         effect: "dark"
      //       },
      //       class: "Orange"
      //     },
      //     val
      //   );
      // }
      // else if (
      //   DiasRetrasados <= 0 &&
      //   isClosed === true &&
      //   (isFixed !== null || isFixed === true)
      // ) {
      //   return createElement(
      //     "el-tag",
      //     {
      //       attrs: {
      //         type: "success",
      //         effect: "dark"
      //       }
      //     },
      //     val
      //   );
      // }
      // else if (
      //   DiasRetrasados > 0 &&
      //   isClosed === true &&
      //   (isFixed !== null || isFixed === true)
      // ) {
      //   return createElement(
      //     "el-tag",
      //     {
      //       attrs: {
      //         type: "danger",
      //         effect: "dark"
      //       }
      //     },
      //     val
      //   );
      // }
      else {
        return createElement(
          "el-tag",
          {
            attrs: {
              type: ""
            }
          },
          val
        );
      }
    } else {
      return createElement("p", "");
    }
  }
};
</script>
<style scoped>
.Orange {
  color: orange;
}
.Red {
  color: red;
}
</style>
